import v18Schema, {
  MigrationTypes as V18Types,
} from "../client/schemaVersions/v18.js";
import v19Schema, {
  MigrationTypes as V19Types,
} from "../client/schemaVersions/v19.js";
import { createMigration } from "@verdant-web/store";

export default createMigration<V18Types, V19Types>(
  v18Schema,
  v19Schema,
  async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
  },
);
